/**
 * @generated SignedSource<<06f3e9d78f58edfbd3933c4b82dbb7dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift$data = {
  readonly endAt: string;
  readonly id: string;
  readonly parts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart">;
  }>;
  readonly startAt: string;
  readonly " $fragmentType": "WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift";
};
export type WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift$key = {
  readonly " $data"?: WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationIpoolShiftPart",
      "kind": "LinkedField",
      "name": "parts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IntegrationIpoolShift",
  "abstractKey": null
};
})();

(node as any).hash = "b1db9244887dbb972bb0b30f87177e51";

export default node;
